import afUsercentricsConsentArray from "../../../Assets/afUsercentric";
import isPwaPage from "../../../Assets/isPwaPage";

(function() {


    document.addEventListener('DOMContentLoaded', (event) => {
        const animatedElementsOnPage = document.querySelectorAll(".fade-in-aos");
        animatedElementsOnPage.forEach( function(item){
            if(isElementXPercentInViewport(item, 15)){
                item.classList.add("fade-in");
            }
        });
    })

// const elementsToFadeInUpOnScroll = document.querySelectorAll(".fade-in-up-on-scroll");
    const elementsToFadeInUpOnScroll = document.querySelectorAll(".fade-in-aos");
    if (elementsToFadeInUpOnScroll) {
        window.addEventListener("scroll", function(event) {
            elementsToFadeInUpOnScroll.forEach(function(element) {
                if ((window.scrollY - 150) >= (element.offsetTop - window.innerHeight)) {
                    if(isElementXPercentInViewport(element, 15)){
                        element.classList.add("fade-in");
                    }
                }
            });
        });
    }

    const isElementXPercentInViewport = function(el, percentVisible) {
        let
            rect = el.getBoundingClientRect(),
            windowHeight = (window.innerHeight || document.documentElement.clientHeight);

        return !(
            Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
            Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
        )
    };

    //Checking whether YouTube-Service was accepted or not so that loading of the videos can be allowed or prevented
    window.addEventListener("load", function(event) {
        const seconds = localStorage.getItem("ucData") ? 0 : 500;
        setTimeout(function() {
            function afShowUsercentric(currentVideo) {
                UC_UI.showFirstLayer();
                if (currentVideo.querySelectorAll('div').length === 0) {
                    const divTag = document.createElement('div');
                    const divTag2 = document.createElement('div');
                    const pTag = document.createElement('p');
                    pTag.innerHTML = afDataProtectionYouTubeText;
                    divTag.appendChild(pTag);
                    divTag.appendChild(divTag2);
                    currentVideo.appendChild(divTag);
                }
            }
            //YouTube Videos
            const videos = document.querySelectorAll('.jonnitto-prettyembed-wrapper a');
            const videosLength = videos.length;

            //Initial consent for the YouTube service
            let youTubeConsentBoolean = false;
            let thirdPartyServices;
            //In case there is ucData in localStorage placed by Usercentrics
            if(localStorage.getItem("ucData")) {
                thirdPartyServices = afUsercentricsConsentArray();
            }
            else {
                thirdPartyServices = [{name: "YouTube Video", consent:{status:false}}];
            }
            const thirdPartyServicesLength = thirdPartyServices.length;

            for (let i = 0; i < thirdPartyServicesLength; i++) {
                youTubeConsentBoolean = thirdPartyServices[i].consent.status;
                if(thirdPartyServices[i].name === "YouTube Video" && thirdPartyServices[i].consent.status === false) {
                    //In case YouTube is not accepted, a new embed attribute is created and value of the old embed attribute is added to it, while the value of the old embed attribute is deleted
                    for(let i = 0; i < videosLength; i++) {
                        if (youTubeConsentBoolean === false) {
                            videos[i].dataset.embed2 = videos[i].dataset.embed;
                            videos[i].dataset.embed = "";
                            const currentVideo = videos[i];
                            (function() {
                                currentVideo.addEventListener("click",function() {afShowUsercentric(currentVideo)});
                            })();
                        }
                    }
                    break;
                }
            }

            window.addEventListener("ucEvent", function (e) {
                //Preference state of the external services on usercentric event
                const thirdPartyServicesLocal = afUsercentricsConsentArray();
                if (e.detail && e.detail.action === "onUpdateServices" || e.detail.action === "onAcceptAllServices" || e.detail.action === "onDenyAllServices") {
                    if (thirdPartyServicesLocal.length === 0) {
                        location.reload();
                    }
                    for (let i = 0; i < thirdPartyServicesLength; i++) {
                        //Getting the index of the matching service in the preference state array after usercentrics event
                        const index = thirdPartyServicesLocal.map(e => e.name).indexOf(thirdPartyServices[i].name);
                        if (thirdPartyServices[i].consent.status !== thirdPartyServicesLocal[index].consent.status) {
                            location.reload();
                        }
                    }
                }
            });
        },seconds)
    });

    if(document.getElementById("af-toggle-page-details-mobile") && document.querySelectorAll(".af-page-mobile-intro-text")[0]) {
        const jobDetailsToggler = document.getElementById("af-toggle-page-details-mobile");

        function afToggleJobInfo(jobDetailsToggler) {
            const jobDetails =  document.querySelectorAll(".af-page-mobile-intro-text")[0];
            jobDetails.classList.contains("af-page-mobile-intro-text-shown") ? jobDetails.classList.remove("af-page-mobile-intro-text-shown") : jobDetails.classList.add("af-page-mobile-intro-text-shown");
            jobDetailsToggler.className = jobDetailsToggler.className.indexOf("open") > -1 ?  jobDetailsToggler.className.replace("open","close") : jobDetailsToggler.className.replace("close","open")
        }
        jobDetailsToggler.addEventListener("click",function () {afToggleJobInfo(jobDetailsToggler)});

        let lastScrollTop = 0;
        function afHideJobInfoOnScrollDown(jobDetailsToggler) {
            let currentScroll = window.scrollY;
            const jobDetails =  document.querySelectorAll(".af-page-mobile-intro-text")[0];
            if (currentScroll > lastScrollTop + 2 && jobDetails.classList.contains("af-page-mobile-intro-text-shown") && jobDetailsToggler.className.indexOf("close") > -1) {
                jobDetails.classList.remove("af-page-mobile-intro-text-shown");
                jobDetailsToggler.className = jobDetailsToggler.className.replace("close","open")
            }

            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative values
        }


        window.addEventListener("scroll", function() {afHideJobInfoOnScrollDown(jobDetailsToggler)});
    }

    const searchPage = document.getElementById("page-header").dataset.searchPage;

    isPwaPage(searchPage)

    //Salary comparison
    const references = new URLSearchParams(window.location.search);
    if(references.has('userSegment')) {
        const userSegment = references.get('userSegment');
        const link = document.querySelectorAll('a[href="https://app.gehaltsreporter.de/report/"]')[0];
        link.href= "https://app.gehaltsreporter.de/report/" + userSegment;
    }
})();
/*
export const isMobile = () => {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const touch = matchMedia('(hover: none)').matches;
    return regex.test(navigator.userAgent) === true || touch === true;
}
 */
